import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

import { I18nextProvider } from "react-i18next";
import i18n from "i18next";
import { HelmetProvider } from "react-helmet-async";

import { initI18n } from "./i18n/initI18n";
import { getDefaultLangFromHostname } from "./utils/getDefaultLangFromHostname";

const hostnameLang = getDefaultLangFromHostname(window.location.hostname);

const rootEl = document.getElementById("root");

async function bootstrap() {
  await initI18n(hostnameLang);

  if (!rootEl) {
    throw new Error("Missing #root element");
  }

  createRoot(rootEl).render(
    <HelmetProvider>
      <I18nextProvider i18n={i18n}>
        <App />
      </I18nextProvider>
    </HelmetProvider>
  );
}

void bootstrap();
